module.exports = __webpack_public_path__ + "img/senias-startseite.15a427bd.png";